<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="blue">
        <h4 slot="title" class="title text-left">Forgot Password</h4>
        <p slot="description" class="description">
          Please enter your email address. If you're registered on our system,
          you'll be sent an email containing instructions on how to reset your
          password.
        </p>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email...</label>
          <md-input v-model="email" type="email"></md-input>
        </md-field>
        <md-button
          type="submit"
          slot="footer"
          class="md-simple md-primary md-lg"
          @click.prevent="forgotPassword"
        >
          Lets Go
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import authApi from "@/services/api/auth";

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      email: null,
      error: false
    };
  },
  methods: {
    forgotPassword() {
      authApi
        .forgotPassword(this.email, { errorHandle: false })
        .then(response => {
          this.email = "";
          this.$notify({
            timeout: 2500,
            message: "Please check your email for Reset instructions.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(err => {
          this.$notify({
            timeout: 2500,
            message:
              (err.response &&
                err.response.data &&
                err.response.data.message) ||
              "Unable to reach the server. Check your connection and try again.",
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.md-card-login {
  .description {
    text-align: left;
    margin-bottom: 2rem;
  }
}
</style>
